import * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'
import gql from 'graphql-tag'

export const DOC = gql`
  fragment FragmentFaFunctionCategorizationIds on FaFunctionCategorization {
    category {
      id
    }
    subcategory {
      id
    }
  }
`

export const TRANSFORMER = graphql.transformers.OUT.object<
  graphql.schema.FragmentFaFunctionCategorizationIdsFragment,
  ents.extra.common.FaFunction.Categorization.Ids
>({
  categoryId: {
    usingFullInput: graphql.transformers.OUT.validate<
      graphql.schema.FragmentFaFunctionCategorizationIdsFragment,
      ents.extra.common.FaFunction.Category.Id,
      string | undefined
    >(
      graphql.transformers.OUT.select(
        'category',
        graphql.transformers.OUT.select('id', transformers.PASS_THROUGH),
      ),
      ents.extra.common.FaFunction.Category.Id.assertIsId,
      { warnOnly: true },
    ),
  },
  subcategoryId: {
    usingFullInput: graphql.transformers.OUT.select(
      'subcategory',
      graphql.transformers.OUT.select(
        'id',
        graphql.transformers.OUT.validate(
          transformers.PASS_THROUGH,
          ents.extra.common.FaFunction.Subcategory.Id.assertIsId,
          { warnOnly: true },
        ),
      ),
    ),
  },
})
